module.exports = __webpack_public_path__ + "static/media/studentteam.0e56391d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/studentteam.svg
// module id = 251
// module chunks = 0